import { useEffect, useState } from "react";

// Default closed until the server confirms downloads are enabled.
export function useDownloadsEnabled(): boolean {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    const controller = new AbortController();
    void fetch("/site-config", { signal: controller.signal, cache: "no-store" })
      .then((response) => response.ok ? response.json() : null)
      .then((config: { downloading?: unknown } | null) => setEnabled(config?.downloading === true))
      .catch(() => {});
    return () => controller.abort();
  }, []);
  return enabled;
}
